export function mergeQuery(url: string, additionalQuery: string | null) {
  if (!url || !additionalQuery) {
    return url;
  }

  return url.includes('?') ? `${url}&${additionalQuery}` : `${url}?${additionalQuery}`;
}
